import {Tab, Tabs} from "../../base/Tabs";
import {Box, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {CreditCardProviders} from "../../../../core/constants/enums";
import NewMonerisCreditCardForm from "./moneris";
import NewStripeCreditCardForm from "./stripe";
import React, {forwardRef, useCallback, useState} from "react";

const NewCreditCardForm = forwardRef(({
                                          onSuccess,
                                          customerId,
                                          setSubmitting,
                                          providers,
                                          setSelectedProvider: setSelectedProviderProps,
                                          providerRenderType = 'tabs',
                                          className,
                                      }, ref) => {
    const [selectedProvider, setSelectedProvider] = useState(providers?.[0]?.name);

    /**
     * Changes the selected provider.
     * @type {(function(*, *): void)}
     */
    const changeSelectedProvider = useCallback((event, newValue) => {
        setSelectedProvider(newValue)
        setSelectedProviderProps?.(newValue)
    }, [setSelectedProviderProps]);

    /**
     * The sx style mixin for the condition's toggle button group.
     */
    const toggleButtonGroupMixin = useCallback((theme) => {
        return ({
            border: `1px solid rgba(var(--palette-common-onBackgroundChannel) / 0.23)`,
            width: '100%',
            '& .MuiToggleButton-root': {
                backgroundColor: 'transparent',
                borderColor: 'transparent !important',
                color: theme.palette.text.primary,
                height: 30,
                marginBlock: 0.5,
                marginInline: 0.5,
                padding: 1,
                width: '50%',
            },
            '& .MuiToggleButton-root:hover': {
                backgroundColor: theme.palette.background.tertiary,
                borderColor: `${theme.palette.background.tertiary} !important`,
                color: theme.palette.text.primary,
            },
            '& .MuiToggleButton-root.Mui-selected': {
                backgroundColor: theme.palette.background.tertiary,
                borderColor: `${theme.palette.background.tertiary} !important`,
                color: theme.palette.primary.main,
            },
            '& .MuiToggleButton-root.Mui-selected:hover': {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.background.tertiary,
                borderColor: `${theme.palette.background.tertiary} !important`,
            },
        })
    }, []);

    return (
        <>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, marginBlock: 1, width: '100%'}}>
                {
                    providers?.length > 1 &&
                    <>
                        {
                            providerRenderType === 'tabs' &&
                            <Tabs value={selectedProvider ?? false} onChange={changeSelectedProvider}>
                                {providers.map((provider) => (
                                    <Tab key={provider.name} value={provider.name} label={provider.title}/>
                                ))}
                            </Tabs>
                        }
                        {
                            providerRenderType === 'buttons' &&
                            <ToggleButtonGroup
                                orientation="horizontal"
                                value={selectedProvider}
                                exclusive
                                onChange={changeSelectedProvider}
                                sx={toggleButtonGroupMixin}
                            >
                                {
                                    providers.map((provider) => (
                                        <ToggleButton value={provider.name} key={provider.name}>
                                            <Typography variant={'overline'} fontWeight={600}>
                                                {provider.title}
                                            </Typography>
                                        </ToggleButton>
                                    ))
                                }
                            </ToggleButtonGroup>
                        }
                    </>
                }
                <Box className={className}>
                    {
                        selectedProvider === CreditCardProviders.moneris &&
                        <NewMonerisCreditCardForm
                            onSuccess={onSuccess}
                            customerId={customerId}
                            setSubmitting={setSubmitting}
                            ref={ref}
                        />
                    }
                    {
                        selectedProvider === CreditCardProviders.stripe &&
                        <NewStripeCreditCardForm
                            onSuccess={onSuccess}
                            customerId={customerId}
                            setSubmitting={setSubmitting}
                            ref={ref}
                        />
                    }
                </Box>
            </Box>
        </>
    );
})

export default NewCreditCardForm;